import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Footer from '../Components/Footer'
import logo from '../Components/img/icon_1.svg';
import "./CSS/Local.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Projects from '../Components/ProjectsCarousel';
import PlanPricing from "./PlanPricing";
import Benefits from "./Benefits";
import ClientCarousel from "./ClientCarousel";
import BookSchedule from "./BookSchedule";
import AddToCartModal from "./AddToCartModal";
import AddToCartButton from "./AddToCartButton";

const strategies = [
    { id: 1, text: "10 Pager Website", color: "red", description: "A website with 10 pages for business or personal use." },
    { id: 2, text: "Admin Panel", color: "blue", description: "Dashboard for managing website operations efficiently." },
    { id: 3, text: "CRM", color: "orange", description: "Customer Relationship Management system for businesses." },
    { id: 4, text: "Staff Panel", color: "yellow", description: "A dedicated panel for staff to manage tasks and reports." },
    { id: 5, text: "Ecommerce Shop", color: "black", description: "An online store for selling products and services." },
    { id: 6, text: "Payment Gateway", color: "purple", description: "A secure way to accept online payments." },
    { id: 7, text: "Auto Employee Salary Calculation", color: "green", description: "Automated salary processing for employees." },
    { id: 8, text: "EMP Attendance", color: "cyan", description: "Tracks employee attendance using selfie & location." },
    { id: 9, text: "Inventory Management", color: "magenta", description: "Sell your products and services, Manages stock levels, orders, and suppliers." },
    { id: 10, text: "Employee Performance Report", color: "brown", description: "Generates detailed performance reports for employees." },
    { id: 11, text: "Leads Management", color: "teal", description: "Track and convert potential leads effectively." },
    { id: 12, text: "Payment Management", color: "pink", description: "Manages transactions and billing records." },
    { id: 13, text: "Location Tracking of Field EMP’s", color: "lime", description: "Real-time location tracking for field employees." },
    { id: 14, text: "Renewals Follow-ups", color: "indigo", description: "Automated reminders for subscription renewals." },
    { id: 15, text: "WhatsApp Integration", color: "gold", description: "Integrate WhatsApp for customer communication." },
    { id: 16, text: "Invoice System", color: "navy", description: "Automated invoice generation and management." },
    { id: 17, text: "Announcements", color: "silver", description: "Send important notifications to employees or users." },
    { id: 18, text: "Expense Calculation", color: "olive", description: "Automates expense tracking and cost management." },
];

const GetWebsiteThripleNine = ({ fetchCartData, totalAmount, triggerClick,setTriggerClick, showCartButton, cartItems }) => {
    const [formVisible, setFormVisible] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const fullUrl = window.location.href;
    const [isBookVisible, setBookVisible] = useState(false);
    const [loading, setLoading] = useState(false);


    const [formData, setFormData] = useState({
        name: "",
        number: "",
        message: "",
        dob:"Website"
    });
    const [error, setError] = useState("");
    const [isHumanChecked, setIsHumanChecked] = useState(false);
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [checkboxErrors, setCheckboxErrors] = useState({
        isHuman: false,
        terms: false,
    });

    const groupedStrategies = [];
    let i = 0;
    while (i < strategies.length) {
        let groupSize = groupedStrategies.length % 2 === 0 ? 2 : 3; // Odd rows get 2, even rows get 3
        groupedStrategies.push(strategies.slice(i, i + groupSize));
        i += groupSize;
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;

        if (name === "number") {
            updatedValue = updatedValue.replace(/[^0-9]/g, '').slice(0, 10);
            if (updatedValue.startsWith("0")) {
                updatedValue = updatedValue.slice(1);
            }
        }

        setFormData((prev) => ({
            ...prev,
            [name]: updatedValue,
        }));

        if (name === "number") {
            if (value.startsWith("0")) {
                setError("Phone number cannot start with 0");
            } else if (updatedValue.length < 10) {
                setError("Phone number must be 10 digits long");
            } else {
                setError("");
            }
        }
    };





    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isHumanChecked || !agreedToTerms) {
            setCheckboxErrors({
                isHuman: !isHumanChecked,
                terms: !agreedToTerms,
            });
            return;
        }
        setLoading(true);

        try {
            const response = await fetch('https://100billionrealestate.com/inquiry', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: formData.name,
                    mobile: formData.number,
                    parent_name: '999/Month',
                    remark: formData.message,
                    skates_category: fullUrl,
                    dob:"Website"
                }),
            });

            if (response.ok) {
                toast.success("Thank you! Our team will contact you soon.", {
                    position: "top-center",
                    autoClose: 10000, // Close toast after 3 seconds
                });
                 // Redirect to home page after submission
                setFormData({
                    service: 'websiteDevelopment',
                    name: '',
                    number: '',
                    email: '',
                    dob:"Website"

                })
                setFormVisible(false);
                setIsHumanChecked(false)
                setAgreedToTerms(false)
                window.location.href = "/start-growing-your-business-at-₹1999/Month";

            } else {

                toast.error("Please try again!", {
                    position: "top-center",
                    autoClose: 10000, // Close toast after 3 seconds
                });

            }
        } catch (error) {
            toast.error(`${error}`, {
                position: "top-center",
                autoClose: 10000, // Close toast after 3 seconds
            });
        } finally {
            setLoading(false);
        }
    };

    console.log(formData);

    return (
        <>

            <div className="service-page-hero-main">
                <div className="service-page-hero-container">
                    <div className="service-page-hero-flex-direction">
                        {/* Update badge */}
                        <div className="service-page-hero-update-badge">Facing Problems Managing Your Business?</div>

                        <div className="service-page-hero-content">
                            {/* Main content */}
                            <div className="service-heading offer-heading">Start Growing Your Business <br />at Just  <span style={{ color: "#007aff" }}>₹1999</span>&nbsp;<span className="cutofpriceomsoffer" style={{ color: "#717171" }}></span><span className="monthwebsiteoms"></span> </div>
                            {/* <span className="yearlyplanplanoffer">With a 1-yr term. You pay ₹ 11,988 today for 1 year.</span> */}
                            <div className="margintophbtplanoffer">Handle everything in one place – website, sales, staff, payments & more!
                            </div>

                            <Link to="#" onClick={() => setFormVisible(true)}>
                                <button className="service-button">Get Started</button>
                            </Link>
                            {/* <Link to="https://api.whatsapp.com/send?phone=918433803555&text=I want to grow my business at ₹999/month">
                                <button className="service-button2">
                                    <i className="fa-brands fa-whatsapp" style={{ marginRight: "10px", color: "green", fontSize: "20px" }}></i>
                                    +91 8433-803-555
                                </button>
                            </Link> */}
                            <button className="book-schedule" onClick={() => setBookVisible(true)}>
                                Book Free Consultation
                            </button>
                        </div>
                        <div></div>
                    </div>


                    {/* Logo */}
                    <div className="service-page-hero-logo">
                        <img src={logo} alt="Logo" />
                    </div>
                </div>
            </div>

            <Benefits fetchCartData={fetchCartData} setTriggerClick={setTriggerClick}/>

            {/* <PlanPricing /> */}

            {/* <div className="strategies-container-hbt">
                <h2 className="title-hbt">Benefits</h2>
                <div className="strategies-list-hbt">
                    {groupedStrategies.map((group, index) => (
                        <div className="row-hbt" key={index}>
                            {group.map((strategy) => (
                                <div key={strategy.id} className={`strategy-item-hbt border-${strategy.color}`}>
                                    {strategy.text}
                                    <span className="tooltip-hbt">{strategy.description}</span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div> */}
            {/* <Projects /> */}

            <div className="call-to-action-hbt call-to-action-hbt2">
                <h2 className="call-to-action-title-hbt">
                    Don’t Wait – Start Managing & Growing Your Business Today!
                </h2>
                {/* <div className="call-to-action-para-hbt">
                    <p>Build your website and grow your business</p>
                </div> */}

                <div className="call-to-action-btn-hbt">
                    <button className="call-to-action-call" onClick={() => window.location.href = 'tel:8433803555'}>
                        Call now
                    </button>

                    <button className="call-to-action-popup" onClick={() => setFormVisible(true)}>Start now</button>
                    <button className="call-to-action-call" onClick={() => setBookVisible(true)}>Book free consultation</button>
                </div>
            </div>

            <ClientCarousel />

            <div className="call-to-action-hbt">
                <h2 className="call-to-action-title-hbt">
                    Start Growing Your Business at Just ₹999/Month!
                </h2>
                <div className="call-to-action-para-hbt">
                    <p>Handle everything in one place – website, sales, staff, payments & more!</p>
                </div>

                <div className="call-to-action-btn-hbt">
                    <button className="call-to-action-call" onClick={() => window.location.href = 'tel:8433803555'}>
                        Call now
                    </button>

                    <button className="call-to-action-popup" onClick={() => setFormVisible(true)}>Start now</button>
                    <button className="call-to-action-call" onClick={() => setBookVisible(true)}>Book free consultation</button>
                </div>
            </div>

            {/* Popup Form */}
            {formVisible && (
                <div className="popup-form-hbt">
                    <div className="popup-content-hbt">
                        <div className="popup-header-hbt">
                            <div className="popup-header-close-hbt" onClick={() => setFormVisible(false)}>
                                <i className="fa-solid fa-xmark desktop-close-hbt"></i>
                                <i className="fa-solid fa-arrow-left mobile-close-hbt"></i>
                            </div>
                            <h3>Get Started</h3>
                            <div></div>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-field-hbt">
                                <label>Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter your name"
                                />
                            </div>
                            <div className="form-field-hbt">
                                <label>Phone Number</label>
                                <input
                                    type="tel"
                                    name="number"
                                    value={formData.number}
                                    onChange={handleChange}

                                    pattern="[0-9]{10}"
                                    placeholder="Enter 10 digit number"
                                    maxLength="10" // Restrict input length
                                    required
                                />
                                {error && <p className="error-message-form">{error}</p>}
                            </div>

                            <div className="form-field-hbt">
                                <label>Message</label>
                                <textarea
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Enter your message"
                                />
                            </div>
                            <div className="form-mainfieldcheck-hbt">
                                <div className="form-fieldcheck-hbt">
                                    <input
                                        type="checkbox"
                                        id="isHuman"
                                        checked={isHumanChecked}
                                        onChange={(e) => {
                                            setIsHumanChecked(e.target.checked);
                                            setCheckboxErrors((prev) => ({ ...prev, isHuman: false }));
                                        }}
                                    />
                                    
                                    <p className="form-terms-hbt">Please check the box to confirm you're human</p>
                                    
                                    

                                </div>
                                {checkboxErrors.isHuman && <p className="error-message-form">Please confirm you're human</p>}
                                <div className="form-fieldcheck-hbt">
                                    <input
                                        type="checkbox"
                                        id="terms"
                                        checked={agreedToTerms}
                                        onChange={(e) => {
                                            setAgreedToTerms(e.target.checked);
                                            setCheckboxErrors((prev) => ({ ...prev, terms: false }));
                                        }}
                                    />
                                    <p className="form-terms-hbt">By submitting, you agree to our <span onClick={() => window.open("https://100billiontech.com/terms-and-conditions", "_blank", "noopener,noreferrer")} style={{cursor:"pointer",color:"#4685f6"}}>terms and conditions</span></p>
                                   

                                </div>
                                {checkboxErrors.terms && <p className="error-message-form">You must agree to the terms</p>}
                            </div>
                            <div className="form-actions-hbt">
                                <button type="submit" disabled={loading} >
                                    {loading ? (
                                        <div className="loader"></div> // Show loader while loading
                                    ) : (
                                        'Submit'
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            <BookSchedule isVisible={isBookVisible} onClose={() => setBookVisible(false)} />
            {cartItems.length > 0 && (
                <div className="fixed-cart-div">
                    <AddToCartButton totalAmount={totalAmount} triggerClick={triggerClick} />
                </div>
            )}
        </>
    );
};

export default GetWebsiteThripleNine;
